import { render, staticRenderFns } from "./enteral-product-form.vue?vue&type=template&id=2a82fda2&scoped=true&lang=pug&"
import script from "./enteral-product-form.vue?vue&type=script&lang=ts&"
export * from "./enteral-product-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82fda2",
  null
  
)

export default component.exports